import script from "./ThuHoiB02aTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThuHoiB02aTable.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__